import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  NgbCarouselModule,
  NgbDropdownModule,
  NgbModule,
} from '@ng-bootstrap/ng-bootstrap';
import { ViewHeaderComponent } from './components/view-header/view-header.component';
import { FormInputDirective } from './directives/form-input.directive';
import { DateFormatDirective } from './directives/date-format.directive';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { LocalPaginationService } from './services/local-pagination.service';
import { DetailFormContainerComponent } from './components/detail-form-container/detail-form-container.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { TabContentDirective } from './directives/tab-content.directive';
import { FileDropComponent } from './components/file-drop/file-drop.component';
import { TableDateFilterComponent } from './components/table-date-filter/table-date-filter.component';
import { NgxFileDropModule } from 'ngx-file-drop';
import { SearchModalComponent } from './components/search-modal/search-modal.component';

@NgModule({
  declarations: [
    ViewHeaderComponent,
    FormInputDirective,
    DateFormatDirective,
    DetailFormContainerComponent,
    TabsComponent,
    TabContentDirective,
    FileDropComponent,
    TableDateFilterComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgbCarouselModule,
    ViewHeaderComponent,
    FormInputDirective,
    DateFormatDirective,
    NgxMaskDirective,
    NgxMaskPipe,
    NgbDropdownModule,
    DetailFormContainerComponent,
    TabsComponent,
    TabContentDirective,
    FileDropComponent,
    TableDateFilterComponent,
    SearchModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgxMaskDirective,
    NgxMaskPipe,
    NgbDropdownModule,
    NgxFileDropModule,
    SearchModalComponent,
  ],
  providers: [
    provideNgxMask(),
    LocalPaginationService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class SharedModule {}
